import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["getSEOHref", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EllipsisOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Pagination } from 'antd';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import React from 'react';
export const itemRender = function (page, type) {
  let {
    getSEOHref
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const props = (() => {
    if (type === 'jump-prev' || type === 'jump-next') {
      return {
        type: 'link'
      };
    }
    return undefined;
  })();
  const content = (() => {
    if (type === 'prev') {
      return /*#__PURE__*/React.createElement(LeftOutlined, null);
    }
    if (type === 'next') {
      return /*#__PURE__*/React.createElement(RightOutlined, null);
    }
    if (type === 'jump-prev' || type === 'jump-next') {
      return /*#__PURE__*/React.createElement(EllipsisOutlined, null);
    }
    if (type === 'page') {
      return page;
    }
    return undefined;
  })();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
    type: 'outline',
    block: false
  }, props), content), getSEOHref && /*#__PURE__*/React.createElement("a", {
    href: getSEOHref(page),
    style: {
      display: 'none'
    }
  }, content));
};
const DixuPagination = _ref => {
  let {
      getSEOHref,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-pagination', className);
  return /*#__PURE__*/React.createElement(Pagination, _extends({
    className: classes
  }, _objectSpread({
    hideOnSinglePage: true,
    showSizeChanger: false,
    itemRender: (page, type) => itemRender(page, type, {
      getSEOHref
    })
  }, rest)));
};
DixuPagination.defaultProps = {
  getSEOHref: undefined
};
export default DixuPagination;